import { render, staticRenderFns } from "./PasswordResetCard.vue?vue&type=template&id=5b277f6e&"
import script from "./PasswordResetCard.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports